<template>
  <div class="">
    <h6 class="font-weight-bold mb-3">Billing address</h6>
    <div class="gird-row">
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Name</span>-->
        <span class="">{{ order?.billing_first_name }} {{ order?.billing_last_name }}</span>
      </div>
<!--      <div class="d-flex flex-column">-->
<!--&lt;!&ndash;        <span class="text-muted mb-2">Company</span>&ndash;&gt;-->
<!--        <span class="">{{ order?.billing_company }}</span>-->
<!--      </div>-->
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Address</span>-->
        <span class="">{{ order?.billing_address_1 }}<span v-if="order?.billing_address_2">,</span> {{ order?.billing_address_2 }}</span>
      </div>
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">City</span>-->
        <span class="">{{order?.billing_city}}, {{ order?.billing_state }}, {{order?.billing_zip}}</span>
      </div>
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Country</span>-->
        <span class="">{{ order?.billing_country }}</span>
      </div>
<!--      <div class="d-flex flex-column">-->
<!--&lt;!&ndash;        <span class="text-muted mb-2">State</span>&ndash;&gt;-->
<!--        <span class="">{{ order?.billing_state }}</span>-->
<!--      </div>-->

      <div class="d-flex flex-column">
        <!--        <span class="text-muted mb-2">Phone</span>-->
        <span class="">{{ order?.billing_phone }}</span>
      </div>
      <div class="d-flex flex-column">
        <!--        <span class="text-muted mb-2">Shipping method</span>-->
        <span class="">{{ order?.shipping_method }}</span>
      </div>
      <div class="d-flex flex-column">
        <!--        <span class="text-muted mb-2">Tax Number</span>-->
        <span class="">{{ order?.billing_tax_no }}</span>
      </div>
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Tax Number</span>-->
        <a :href="`mailto:${order?.billing_email}`" class="text-underline">
          <span class="">{{ order?.billing_email }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingAddress",
  props:['order'],

}
</script>

<style scoped lang="scss">
.gird-row {
  display: grid;
  width: 100%;
  gap: 5px;
  //grid-template-columns: repeat(9, 1fr);
  margin-bottom: 1rem;
  //padding: 10px 15px;

}

h6 {
  font-size: 18px;
}
</style>
